"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var AffilatesPromoCodeTemplatesListCtl = /** @class */ (function (_super) {
    __extends(AffilatesPromoCodeTemplatesListCtl, _super);
    function AffilatesPromoCodeTemplatesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_promocode_template_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promocode_template_id; });
        _this.dk_promocode_template_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promocode_template_title; });
        _this.dk_promocode_template_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promocode_template_type_title; });
        _this.dk_promocode_template_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promocode_template_description; });
        _this.dk_max_promo_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.max_promo_count; });
        _this.dk_is_deprecated = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_deprecated; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    AffilatesPromoCodeTemplatesListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    AffilatesPromoCodeTemplatesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "affilate promo code template with id [" + id + "] not found !";
    };
    AffilatesPromoCodeTemplatesListCtl.prototype.LoadData = function (PProgramId, onDone) {
        var _this = this;
        webAApi_1.ListPromoTemplatesByPProgramIdGet.exec({ pprogram_id: PProgramId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    promocode_template_id: resp.list[i].promocode_template_id,
                    promocode_template_title: resp.list[i].promocode_template_title,
                    promocode_template_type_title: resp.list[i].promocode_template_type_title,
                    promocode_template_description: resp.list[i].promocode_template_description,
                    max_promo_count: resp.list[i].max_promo_count,
                    is_deprecated: resp.list[i].is_deprecated,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AffilatesPromoCodeTemplatesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPProgramPromoTemplate.exec({
            data: {
                promocode_template_id: data.promocode_template_id,
                pprogram_id: data.pprogram_id,
                max_promo_count: data.max_promo_count,
                is_deprecated: data.is_deprecated
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                brand_id: resp.brand_id,
                brand_title: resp.brand_title,
                promocode_template_id: data.promocode_template_id,
                promocode_template_title: resp.template_title,
                promocode_template_type_title: resp.template_type_title,
                promocode_template_description: resp.template_description,
                max_promo_count: data.max_promo_count,
                is_deprecated: data.is_deprecated,
                date_changed2: moment(resp.date_added_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false)
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AffilatesPromoCodeTemplatesListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    AffilatesPromoCodeTemplatesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePProgramPromoTemplate.exec({
                data: {
                    pprograme_promocode_template_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AffilatesPromoCodeTemplatesListCtl.prototype.DoSetIsDeprecated = function (key, isLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPProgramPromoTemplateIsDeprecated.exec({ data: { pprogram_promo_template_id: key, is_deprecated: isLocked } }, function (resp) {
                _tmp.is_deprecated = isLocked;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return AffilatesPromoCodeTemplatesListCtl;
}(BaseController_1.BaseController));
exports.AffilatesPromoCodeTemplatesListCtl = AffilatesPromoCodeTemplatesListCtl;
/*export interface IEditAffilatePromoCodeTemplateItem {

    key: number;

    promocode_template_id: number;

    max_promo_count: number;

    is_deprecated: boolean;

}*/ 



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ctl/options/AffilatesPromoCodeTemplatesListCtl.ts
// module id = 999
// module chunks = 0